
export const actionTypes = {
	GET_SITES: 'generalFilter/edit/GET_SITES',
	GET_ASSET_GROUPS: 'generalFilter/edit/GET_ASSET_GROUPS',
	SET_SELECTED_FILTERS: 'generalFilter/edit/SET_SELECTED_FILTERS',
	CLEAR_STORE: 'generalFilter/edit/CLEAR_STORE',
	POPULATE_STORE: 'generalFilter/edit/POPULATE_STORE',
	CIAM_SEARCH_ORGANIZATION: 'generalFilter/edit/CIAM_SEARCH_ORGANIZATION',
};
